/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trick_Slow_Deer_FavorInputs */

const fr_trick_slow_deer_favor = /** @type {(inputs: Trick_Slow_Deer_FavorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refuser le Dropin`)
};

/**

* @param {Trick_Slow_Deer_FavorInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const trick_slow_deer_favor = /** @type {((inputs?: Trick_Slow_Deer_FavorInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trick_Slow_Deer_FavorInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_trick_slow_deer_favor(inputs)
});